export function stripQueryParams(url) {
    const queryIndex = url.indexOf('?');
    return queryIndex !== -1 ? url.slice(0, queryIndex) : url;
}